import {formatDate, formatTime} from "@/src/modules/core/lib/formatters";

/** Full shift start/end — matches `CoverageList` roster rows. */
export function formatShiftWindow(fromDatetime: string, toDatetime: string): string {
  return `${formatDate(fromDatetime)} ${formatTime(fromDatetime)} – ${formatDate(toDatetime)} ${formatTime(toDatetime)}`;
}
